import React, { useEffect } from 'react';
import FiltersSidebar from '../FiltersSidebar/FiltersSidebar';
import './MobileFilters.css';

function MobileFilters({ isOpen, onClose, filters, onFilterChange }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className="mobile-filters-overlay" onClick={onClose} />
      <div className={`mobile-filters-drawer ${isOpen ? 'open' : ''}`}>
        <div className="mobile-filters-header">
          <h3>Filters</h3>
          <button className="btn-close-filters" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="mobile-filters-content">
          <FiltersSidebar filters={filters} onFilterChange={onFilterChange} />
        </div>

        <div className="mobile-filters-footer">
          <button className="btn-reset-mobile" onClick={() => onFilterChange('reset')}>
            Reset
          </button>
          <button className="btn-apply-mobile" onClick={onClose}>
            Apply Filters
          </button>
        </div>
      </div>
    </>
  );
}

export default MobileFilters;